import React from "react";

export default function Separate() {
    return(
        <div className="menu-separate"></div>
    );
}